import SmartPhoneImg from "../../../images/pages/smartphone-product.png";
import LaptopImg from "../../../images/pages/laptop-product.png";
import "./styles.css";
import SubBannerCarousel from "./SubBannerCarousel/SubBannerCarousel";

const BestDeals = ({ image1, image2, image3, isPreview = true, delaySubSlider }) => {
  return (
    <div className="containerCardBanners gap-4 mt-4 w-full grid-nogutter">
      {isPreview ? (
        <>
          {image1 ? (
            <SubBannerCarousel items={image1} timeToChangeImg={delaySubSlider} />
          ) : (
            <>
              <div
                className="grid gap-3 mb-0 grid-nogutter relative rounded-lg shadow-lg px-4 py-6 card border-none overflow-hidden relative"
                style={{
                  backgroundColor: "#315C5A",
                }}
              >
                <div
                  className="card p-2 absolute flex align-items-top gap-2  border-none"
                  style={{
                    top: "1rem",
                    right: "1rem",
                    backgroundColor: "#FFDE88",
                    color: "#315C5A",
                  }}
                >
                  <i className="pi pi-tag mt-1"></i>
                  <div>
                    <div className="font-bold text-sm">10%</div>
                    <div className="text-xs">OFF</div>
                  </div>
                </div>
                <div className="col flex flex-column gap-3">
                  <div className="text-sm font-medium text-white line-height-3">
                    Smartphone LG K22 Dual Chip Android 10
                  </div>
                  <div>
                    <div className="font-bold text-2xl" style={{ color: "#FFC839" }}>
                      R$ 2.620,00
                    </div>
                    <div className="text-sm text-white">em até 10x de R$ 162,20</div>
                  </div>
                </div>
                <div
                  className="col"
                  style={{ marginBottom: "calc(-70% - 1rem)", marginRight: "-15px" }}
                >
                  <img src={SmartPhoneImg} alt="Smartphone" className="w-full" />
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>{image1 && <SubBannerCarousel items={image1} timeToChangeImg={delaySubSlider} />}</>
      )}

      {isPreview ? (
        <>
          {image2 ? (
            <SubBannerCarousel items={image2} timeToChangeImg={delaySubSlider} />
          ) : (
            <div
              className="grid gap-3 mb-0 grid-nogutter relative rounded-lg shadow-lg px-4 py-6 card border-none overflow-hidden relative"
              style={{ backgroundColor: "#315C5A" }}
            >
              <div
                className="card p-2 absolute flex align-items-top gap-2  border-none"
                style={{ top: "1rem", right: "1rem", backgroundColor: "#FFDE88", color: "#315C5A" }}
              >
                <i className="pi pi-tag mt-1"></i>
                <div>
                  <div className="font-bold text-sm">10%</div>
                  <div className="text-xs">OFF</div>
                </div>
              </div>
              <div className="col flex flex-column gap-3">
                <div className="text-sm font-medium text-white line-height-3">
                  Smartphone LG K22 Dual Chip Android 10
                </div>
                <div>
                  <div className="font-bold text-2xl" style={{ color: "#FFC839" }}>
                    R$ 2.620,00
                  </div>
                  <div className="text-sm text-white">em até 10x de R$ 162,20</div>
                </div>
              </div>
              <div
                className="col"
                style={{ marginBottom: "calc(-70% - 1rem)", marginRight: "-15px" }}
              >
                <img src={SmartPhoneImg} alt="Smartphone" className="w-full" />
              </div>
            </div>
          )}
        </>
      ) : (
        <>{image2 && <SubBannerCarousel items={image2} timeToChangeImg={delaySubSlider} />}</>
      )}

      {isPreview ? (
        <>
          {image3 ? (
            <SubBannerCarousel items={image3} timeToChangeImg={delaySubSlider} />
          ) : (
            <div
              className="grid gap-3 mb-0 grid-nogutter relative rounded-lg shadow-lg px-4 py-6 card border-none overflow-hidden relative"
              style={{ backgroundColor: "#315C5A" }}
            >
              <div
                className="card p-2 absolute flex align-items-top gap-2  border-none"
                style={{ top: "1rem", right: "1rem", backgroundColor: "#FFDE88", color: "#315C5A" }}
              >
                <i className="pi pi-tag mt-1"></i>
                <div>
                  <div className="font-bold text-sm">10%</div>
                  <div className="text-xs">OFF</div>
                </div>
              </div>
              <div className="col flex flex-column gap-3">
                <div className="text-sm font-medium text-white line-height-3">
                  Notebook Lenovo Ideapad S145 Intel Core I3 4gb 1TB{" "}
                </div>
                <div>
                  <div className="font-bold text-2xl" style={{ color: "#FFC839" }}>
                    R$ 2.620,00
                  </div>
                  <div className="text-sm text-white">em até 10x de R$ 162,20</div>
                </div>
              </div>
              <div
                className="col"
                style={{ marginBottom: "calc(-13% - 1rem)", marginRight: "-30px" }}
              >
                <img src={LaptopImg} alt="Laptop" className="w-full" />
              </div>
            </div>
          )}
        </>
      ) : (
        <>{image3 && <SubBannerCarousel items={image3} timeToChangeImg={delaySubSlider} />}</>
      )}
    </div>
  );
};

export default BestDeals;
